const EDITABLE_SELECTOR = [
  "input",
  "textarea",
  "select",
  '[contenteditable=""]',
  '[contenteditable="true"]',
  '[contenteditable="plaintext-only"]',
  '[role="textbox"]',
].join(",");

/**
 * Whether a text-editing element owns the keyboard. A shortcut sharing its
 * chord with native editing — mod+z above all — has to yield when this is true,
 * or it takes the undo out from under someone mid-sentence.
 *
 * Matches an ancestor too, not just the event target: a composer's real caret
 * often sits on a child of the element carrying `contenteditable`.
 */
export function isEditableFocused(target: EventTarget | null = document.activeElement): boolean {
  return target instanceof Element && target.closest(EDITABLE_SELECTOR) !== null;
}
